import {API_SERVERLESS, getFetch} from '../../../../../../commonApi';

export function apiTloApplicationsCommonsExaminationContractSpecies(): Promise<any> {
    return getFetch(`${API_SERVERLESS}/tlo/applications/commons/examinationContractSpecies`, true);
}
